import { store } from "../../redux/store";
import { queryList } from "../api/common";

export const fetchInvestigations = async (type, category) => {
  const { id } = store.getState().gameStates.case;

  try {
    return (
      await queryList(
        "client/investigations",
        `caseId=${id}&type=${type}&category=${category}`
      )
    ).data;
  } catch (e) {
    return [];
  }
};
